'use client';
import { useSession } from 'next-auth/react';
import { useEffect, useRef } from 'react';
import { clearClientStores } from '@/stores/clearClientStores';

export default function SessionStoreGuard() {
  const { status } = useSession();
  const previousStatus = useRef(status);

  useEffect(() => {
    if (
      previousStatus.current !== 'unauthenticated' &&
      status === 'unauthenticated'
    ) {
      clearClientStores();
    }
    previousStatus.current = status;
  }, [status]);

  return null;
}
